<template>
  <fragment>
    <v-col cols="12" md="8">
      <BaseFormSelect
        placeholder="Nome"
        v-model="value.escritorios"
        validate-on-blur
        item-text="nome_fantasia"
        item-value="id"
        :return-object="true"
        :items="officeList"
        multiple
      />
    </v-col>
  </fragment>
</template>

<script>
export default {
  name: "AdvisoryDetails",
  props: {
    value: { type: Object },
    officeList: { type: Array }
  }
};
</script>
